<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AIZXDH/tc-custom/9780300189315.jpg?1708779379338" alt="This image is the cover for the book Crusader States"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crusader States
      </h1>
      <p class="bookDescription body article font2">
        <b>“An enriching account of the expansion of the political and cultural frontiers of the Latin West in the central Middle Ages.”—<i>History Today</i></b><br/>  <br/> When the armies of the First Crusade wrested Jerusalem from control of the Fatimids of Egypt in 1099, they believed their victory was an evident sign of God’s favor. It was, therefore, incumbent upon them to fulfill what they understood to be God’s plan: to re-establish Christian control of Syria and Palestine. This book is devoted to the resulting settlements, the crusader states, that developed around the eastern shores of the Mediterranean and survived until Richard the Lionheart’s departure in 1192. Focusing on Jerusalem, Antioch, Tripoli, and Edessa, Malcolm Barber vividly reconstructs the crusaders’ arduous process of establishing and protecting their settlements, and the simultaneous struggle of vanquished inhabitants to adapt to life alongside their conquerors. <br/>  <br/> Rich with colorful accounts of major military campaigns, the book goes much deeper, exploring in detail the culture of the crusader states—the complex indigenous inheritance, the architecture, the political, legal, and economic institutions, the ecclesiastical framework through which the crusaders perceived the world, the origins of the Knights Templar and the Hospitallers, and more. With the zest of a scholar pursuing a life-long interest, Barber presents a complete narrative and cultural history of the crusader states while setting a new standard for the term “total history.”<br/>  <br/><b>A <i>Choice</i> Outstanding Academic Title in the Western Europe Category</b><br/>  <br/> “Barber is a highly distinguished scholar, whose touch is continually deft, and he navigates the basis of the main narrative histories with care . . . a delight to read.”—<i>Literary Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Barber
      </h2>
      
      <p class="authorDescription body article">Malcolm Barber is emeritus professor of history, University of Reading. He lives in Reading, UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13f6f716